<template>
    <div>
        <!-- <topSearch></topSearch> -->
        <!-- <breadcrumb></breadcrumb> -->

        <div class="top-title-content">
            <span class="title">메시지 내용 설정</span>
            <span class="txt">
                회원에게 발송할 안내 문구 또는 자주 사용하는 문자 내용을 미리 등록하고 설정할 수 있습니다.
            </span>
        </div>

        <div class="com-tab">
            <button @click="onClickRouter('/madmin/message/setting/auto')">자주 사용하는 문자</button>
            <button class="on">알림톡 템플릿</button>
        </div>

        <div class="com-cont-wrap" v-if="isProfileComplete">
            <p class="sub-title small">발송 정보</p>
            <div class="com-card-input full other">
                <div class="line">
                    <span class="tit">
                        플러스친구 아이디
                        <span class="require">*</span>
                    </span>
                    <div class="input-cnt plus-friend-id-input">
                        <input
                            type="text"
                            placeholder="플러스 친구 검색용 아이디 @포함 하여 입력해 주세요."
                            readonly
                            v-model="name"
                        />
                    </div>
                </div>
                <div class="line">
                    <span class="tit">
                        카테고리 코드(대분류)
                        <span class="require">*</span>
                    </span>
                    <div class="input-cnt">
                        <input type="text" readonly v-model="selectedCategoryName" />
                    </div>
                </div>
            </div>
        </div>
        <div v-else class="com-cont-wrap">
            <p class="sub-title small">발송 정보</p>
            <div class="com-card-input full other">
                <div class="line">
                    <span class="tit">
                        플러스친구 아이디
                        <span class="require">*</span>
                    </span>
                    <div class="input-cnt plus-friend-id-input">
                        <input
                            type="text"
                            placeholder="플러스 친구 검색용 아이디 @포함 하여 입력해 주세요."
                            v-model="yellowId"
                        />
                    </div>
                </div>
                <div class="line">
                    <span class="tit">
                        휴대폰번호
                        <span class="require">*</span>
                    </span>
                    <div class="input-cnt input-btn-wrap">
                        <input
                            type="text"
                            placeholder="숫자만 입력해 주세요."
                            v-model="phoneNumber"
                            @input="phoneNumber = $event.target.value.replace(/\D/g, '')"
                        />
                        <button type="button" class="com-btn dark-gray" @click="registerPlusFriend">인증 요청</button>
                    </div>
                </div>
                <div class="line">
                    <span class="tit">
                        인증번호 입력
                        <span class="require">*</span>
                    </span>
                    <div class="input-cnt">
                        <input type="text" placeholder="인증번호를 입력해주세요." v-model="token" />
                    </div>
                </div>
                <div class="line">
                    <span class="tit">
                        카테고리 코드(대분류)
                        <span class="require">*</span>
                    </span>
                    <div class="input-cnt">
                        <select-form
                            :select-data="['선택', ...categoryCodes.map((category) => category.name)]"
                            :select-value="['', selectedCategoryCode]"
                            @update:set="updateSelectedCategoryCode"
                            @update:selected="updateSelectedCategoryCode"
                        ></select-form>
                    </div>
                </div>
                <!-- <div class="line">
                    <span class="tit">
                        카테고리 코드(중분류)
                        <span class="require">*</span>
                    </span>
                    <div class="input-cnt">
                        <select-form :select-data="['선택', ...subCategoryCodes]"
                            :select-value="['', selectedSubCategoryCode]" @update:set="updateSelectedSubCategoryCode"
                            @update:selected="updateSelectedSubCategoryCode"></select-form>
                    </div>
                </div> -->
                <div class="bottom-btn">
                    <button class="com-btn" @click="resetFields">취소</button>
                    <button class="com-btn blue" @click="registerProfile">플러스친구 등록</button>
                </div>
            </div>
        </div>

        <div class="com-cont-wrap">
            <p class="sub-title small">자동 발송 메시지</p>
            <div class="com-info-wrap">
                <div class="tit">
                    <span>자동 치환 문자 안내</span>
                    <div class="com-tooltip">
                        <button class="icon"></button>
                        <div class="detail">
                            <span class="tit">이용권 결제등록 완료시점에 자동발송 됩니다.</span>
                            <p class="txt">
                                <span class="red">[추가 사용 가능한 치환문자]</span>
                                <br />
                                #{담당강사} : 이용권의 지정된 담당강사
                                <br />
                                #{이용권명} : 이용권명
                                <br />
                                #{유효기간} : (예시 : 2020-01-01 ~ 2020-02-28)
                            </p>
                        </div>
                    </div>
                </div>
                <div class="com-info-cont-list">
                    <dl>
                        <span style="cursor: pointer; color: #4780fd" @click="copy($event)">#{회원명}</span>
                        <dd>회원 이름</dd>
                    </dl>
                    <dl>
                        <span style="cursor: pointer; color: #4780fd" @click="copy($event)">#{이용권명}</span>
                        <dd>이용권명</dd>
                    </dl>
                    <dl>
                        <span style="cursor: pointer; color: #4780fd" @click="copy($event)">#{센터명}</span>
                        <dd>센터명({{ centerInfo.centerName }})</dd>
                    </dl>
                    <dl>
                        <span style="cursor: pointer; color: #4780fd" @click="copy($event)">#{센터번호}</span>
                        <dd>센터대표전화번호 ({{ centerInfo.telNo | phoneNumberFilter }})</dd>
                    </dl>
                    <dl>
                        <span style="cursor: pointer; color: #4780fd" @click="copy($event)">#{유효기간}</span>
                        <dd class="w220">이용권 유효기간(YYYY-MM-DD ~ YYYY-MM-DD)</dd>
                    </dl>
                    <dl>
                        <span style="cursor: pointer; color: #4780fd" @click="copy($event)">#{종료일}</span>
                        <dd>이용권 종료일</dd>
                    </dl>
                    <dl>
                        <span style="cursor: pointer; color: #4780fd" @click="copy($event)">#{담당강사}</span>
                        <dd>이용권 지정 담당강사</dd>
                    </dl>
                    <dl>
                        <span style="cursor: pointer; color: #4780fd" @click="copy($event)">#{강사명}</span>
                        <dd>예약된 수업의 강사명</dd>
                    </dl>
                    <dl>
                        <span style="cursor: pointer; color: #4780fd" @click="copy($event)">#{강사번호}</span>
                        <dd>예약된 수업의 연락처</dd>
                    </dl>
                    <dl>
                        <span style="cursor: pointer; color: #4780fd" @click="copy($event)">#{수업일시}</span>
                        <dd>예약된 수업일시</dd>
                    </dl>
                </div>
            </div>

            <ul class="auto-send-msg template-msg">
                <li v-for="(section, idx) in templateSections" :key="idx">
                    <div class="accordion-tit" @click="toggleSection(idx)">
                        <span>{{ idx === 0 ? '자동발송 템플릿' : '직접발송 템플릿' }}</span>
                        <span :class="{ 'ico-arrow': true, on: section.expanded }"></span>
                    </div>
                    <div
                        :class="{
                            'accordion-desc': true,
                            on: section.expanded,
                        }"
                    >
                        <div class="phone-list">
                            <div
                                v-for="template in section.templates"
                                :key="`${section.type}-${template.id}`"
                                class="phone-item"
                            >
                                <!-- 상태, 사용여부 체크박스, 템플릿 제목, 메시지 내용 등 기타 필요한 요소들... -->
                                <div class="top-area">
                                    <div class="line">
                                        <div class="badge-wrap">
                                            <span :class="['badge', 'state-' + getBadgeClass(template.state)]">
                                                {{ template.state }}
                                            </span>
                                            <button
                                                v-if="template.state === '반려'"
                                                @click="showReturnReason(template.id)"
                                                class="return-reason-btn"
                                                style="
                                                    color: red;
                                                    text-decoration: underline red;
                                                    font-size: calc(100% - 3px);
                                                    border: none;
                                                    background: none;
                                                    cursor: pointer;
                                                "
                                            >
                                                반려 사유
                                            </button>
                                        </div>
                                        <!-- <div class="check">
                                            <div class="check-label">사용여부</div>
                                            <div class="com-design-check">
                                                <input type="checkbox" :id="'check-sms-' + template.id"
                                                    v-model="template.isChecked"
                                                    @click="handleCheckboxClick(template.state)" />
                                                <label :for="'check-sms-' + template.id"></label>
                                            </div>
                                        </div> -->
                                        <div class="check">
                                            <div class="check-label">사용여부</div>
                                            <div class="com-design-check">
                                                <input
                                                    type="checkbox"
                                                    :id="'check-sms-' + template.id"
                                                    :checked="template.isChecked"
                                                    @click="handleCheckboxClick(template)"
                                                />
                                                <label :for="'check-sms-' + template.id"></label>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="com-phone-sms other">
                                    <div class="line">
                                        <span class="tit">
                                            <span>템플릿 제목</span>
                                        </span>
                                        <div class="input-cnt">
                                            <input
                                                type="text"
                                                v-model="template.title"
                                                :readonly="
                                                    template.state === '승인' ||
                                                    template.state === '반려' ||
                                                    template.state === '심사중'
                                                "
                                                placeholder="템플릿 제목 입력"
                                            />
                                        </div>
                                    </div>
                                    <div class="line msg-cont-wrap">
                                        <span class="tit">
                                            <span>메시지 내용</span>
                                        </span>
                                        <textarea
                                            v-model="template.content"
                                            @input="checkModification(template)"
                                            :readonly="
                                                template.state === '승인' ||
                                                template.state === '반려' ||
                                                template.state === '심사중'
                                            "
                                            placeholder="#{회원명} 님 #{수업일시}이 예약 되었습니다. 
감사합니다."
                                        />
                                        <div class="info-line">
                                            <span class="num">{{ charCalculator(template.content) }}</span>
                                            / 2000 byte
                                        </div>
                                    </div>
                                </div>

                                <div class="bottom-area">
                                    <div class="btn-wrap">
                                        <button
                                            class="com-btn com-btn-del"
                                            :disabled="
                                                template.state !== '대기' &&
                                                template.state !== '승인' &&
                                                template.state !== '반려'
                                            "
                                            @click="deleteTemplate(template)"
                                        >
                                            삭제
                                        </button>
                                        <button
                                            class="com-btn w100per"
                                            :disabled="template.state !== '대기'"
                                            @click="submitTemplate(template)"
                                        >
                                            심사요청
                                        </button>
                                    </div>
                                </div>
                            </div>
                            <!-- 추가 영역 -->
                            <div
                                class="phone-item phone-add-item"
                                @click="addTemplate(idx)"
                                v-if="section.templates.length < 10"
                            >
                                <i class="ico-plus-2"></i>
                                추가
                            </div>
                        </div>
                    </div>
                </li>
            </ul>
        </div>

        <!-- 반려 사유 레이어 팝업 -->
        <div v-show="returnReasonPop" class="layer-pop square">
            <div class="view-content w400">
                <button class="close" @click="returnReasonPop = false">
                    <span class="blind">팝업 닫기</span>
                </button>
                <div class="scroll-area com-scroll-y">
                    <p class="pop-tit">반려 사유</p>
                    <div class="return-reason-box">
                        <textarea
                            placeholder="%반려 사유%"
                            v-model="this.returnReason"
                            readonly
                            style="color: black; background-color: white"
                        ></textarea>
                        <div class="bottom-btn">
                            <button class="com-btn" @click="returnReasonPop = false">확인</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import api from '@/assets/js/api';
import paymentApi from '@/assets/js/paymentApi';

export default {
    name: 'messageSendAlert',
    props: {},
    computed: {
        cId() {
            const { getters } = this.$store;
            return getters['auth/cId'];
        },
        staffId() {
            const { getters } = this.$store;
            return getters['auth/staffId'];
        },
        isProfileComplete() {
            return (
                this.uuid !== null &&
                this.uuid !== undefined &&
                this.categoryCode !== null &&
                this.categoryCode !== undefined
            );
        },
        selectedCategoryName() {
            const category = this.categoryCodes.find((cat) => cat.code === this.categoryCode);
            return category ? category.name : null;
        },
    },
    watch: {
        async selectedCategoryCode(newVal) {
            const selectedCategory = this.categoryCodes.find((category) => category.name === newVal);
            if (selectedCategory) {
                this.categoryCode = selectedCategory.code; // categoryCode 데이터 속성에 값을 저장
                await this.fetchSubCategoryCodes(selectedCategory.code);
            } else {
                this.subCategoryCodes = [];
                this.selectedSubCategoryCode = '';
            }
        },
    },
    data() {
        return {
            centerId: '',
            centerInfo: {},
            sendName: '',
            sendNo: '',
            //staffId: '',
            staffIdId: '',
            searchStr: '',
            messages: [],
            templateList: [],
            templateSections: [
                {
                    expanded: true,
                    type: 'auto',
                    templates: [],
                },
                {
                    expanded: true,
                    type: 'manual',
                    templates: [],
                },
            ],
            returnReasonPop: false, // 반려 사유 팝업의 표시 여부
            returnReason: '', // 반려 사유 내용
            categoryCodes: [], // 카테고리 코드 목록
            selectedCategoryCode: '', // 사용자가 선택한 대분류 카테고리 코드
            subCategoryCodes: [], // 중분류 카테고리 코드 목록
            selectedSubCategoryCode: '', // 사용자가 선택한 중분류 카테고리 코드
            yellowId: '',
            phoneNumber: '',
            name: '',
            uuid: null,
            categoryCode: null,
            token: '',
            senderKey: null,
        };
    },

    mounted() {
        try {
            if (this.$route.params.data === undefined) {
                this.paramArray = [];
            } else {
                this.paramArray = this.$route.params.data;
                this.$route.params.data.map((elements) => {
                    this.selected.push(elements);
                });
            }
        } catch (error) {
            this.paramArray = [];
        }
        this.centerId = this.cId; // 센터id
        this.staffIdId = this.staffId; // 직원id
        this.init();
        this.fetchCategoryCodes();
        this.fetchKakaoProfile();
        this.refreshTemplates();
    },

    methods: {
        // 초기화
        async init() {
            try {
                const { data } = await this.getCenterInfo();
                this.centerInfo = data;
                const response = await this.getTemplateList();
                this.processTemplates(response.data);
            } catch (error) {
                console.log(error);
            }
        },
        formatPhoneNumber(value) {
            if (value) {
                let phone = value.replace(/[^0-9]/g, ''); // 숫자가 아닌 문자 제거
                if (phone.length === 11) {
                    return phone.replace(/(\d{3})(\d{4})(\d{4})/, '$1-$2-$3'); // 하이픈 추가
                } else if (phone.length === 10) {
                    return phone.replace(/(\d{3})(\d{3})(\d{4})/, '$1-$2-$3'); // 하이픈 추가
                } else if (phone.length === 9) {
                    return phone.replace(/(\d{2})(\d{3})(\d{4})/, '$1-$2-$3'); // 하이픈 추가
                }
            }
            return value;
        },
        toggleSection(index) {
            this.templateSections[index].expanded = !this.templateSections[index].expanded;
        },
        getBadgeClass(state) {
            switch (state) {
                case '대기':
                    return 'wait';
                case '심사중':
                    return 'ing';
                case '승인':
                    return 'approval';
                case '반려':
                    return 'companion';
                default:
                    return '';
            }
        },
        addTemplate(sectionIndex) {
            const section = this.templateSections[sectionIndex];
            if (section.templates.length < 10) {
                const newId = new Date().getTime(); // 유니크한 ID 생성
                const newTemplate = {
                    id: newId,
                    state: '대기',
                    title: '',
                    content: '',
                    byteCount: 0,
                    isChecked: false,
                    type: section.type,
                };
                if (section.type === 'auto') {
                    // 자동발송 템플릿에 대한 추가 처리...
                } else if (section.type === 'manual') {
                    // 직접발송 템플릿에 대한 추가 처리...
                }
                section.templates.push(newTemplate);
            } else {
                alert('최대 10개까지만 추가할 수 있습니다.');
            }
        },
        removeTemplate(templateId) {
            const section = this.templateSections[0];
            const index = section.templates.findIndex((t) => t.id === templateId);
            if (index !== -1) {
                section.templates.splice(index, 1);
            }
        },
        byteCal(byte) {
            if (byte !== undefined) {
                const pattern = /[\u0000-\u007f]|([\u0080-\u07ff]|(.))/g;
                const result = byte.replace(pattern, '$&$1$2').length;
                if (result > 2000) {
                    alert('내용은 2000byte를 넘을수 없습니다.');
                    return result;
                }
                return result;
            }
        },
        // 문자 수 계산
        charCalculator(val) {
            if (val == undefined || val == '') {
                val = '';
            }
            let str = val; // 내용
            const str_len = str.length; // 길이

            let rlen = 0;
            let one_char = '';
            let maxLength = 1000;

            for (let i = 0; i < str_len; i++) {
                one_char = str.charAt(i); // char 단위로 구분해서 문자 수 구분
                if (i <= maxLength) {
                    rlen = i + 1; // return 할 문자열 갯수
                }
            }
            // 넘어가는 글자는 자른다
            if (str_len > maxLength) {
                alert(`${maxLength}자를 초과 입력 할 수 없습니다.`);
                str = str.substr(0, rlen);
                val = str;
            } else if ((maxLength = 0)) {
                alert('문자 형식을 선택 해주세요.');
            } else {
                return str_len;
            }
        },
        fnChkByte(value, e) {
            value.content = e.target.value;
        },
        getCenterInfo() {
            return api.get(`/admin/api/center/${this.centerId}`);
        },
        copy(event) {
            navigator.clipboard.writeText(event.target.innerText);
            return false;
        },
        async getTemplateList() {
            try {
                const response = await paymentApi.get(`/admin/api/kakaotalk/list/template/${this.centerId}`);
                const filteredTemplates = response.data.filter((template) => template.sender_key === this.senderKey);
                return { data: filteredTemplates };
            } catch (error) {
                console.error(error);
            }
        },

        processTemplates(data) {
            const stateMapping = {
                REG: '심사중', //등록
                REQ: '심사중',
                APR: '승인',
                KRR: '등록거절',
                REJ: '반려',
            };
            this.templateSections[0].templates = [];
            this.templateSections[1].templates = [];
            data.forEach((template) => {
                const sectionIndex = template.send_method === 'auto' ? 0 : 1;
                const titleParts = template.template_name.split('/');
                const title = titleParts.slice(1).join('/');
                this.templateSections[sectionIndex].templates.push({
                    id: template.id,
                    state: stateMapping[template.inspection_status] || '대기',
                    title: title,
                    content: template.template_content,
                    originalContent: template.template_content,
                    isModified: false,
                    isChecked: template.use_yn,
                    type: template.send_method,
                });
            });
        },
        checkModification(template) {
            template.isModified = template.content !== template.originalContent;
        },
        refreshTemplates() {
            paymentApi
                .post(`/admin/api/kakaotalk/status/template/${this.centerId}`)
                .then((response) => {
                    console.log('refreshTemplates response', response);
                })
                .catch((error) => {
                    console.error(error);
                });
        },
        modifyTemplate(template) {
            const params = {
                title: template.title,
                content: template.content,
                useKakao: template.isChecked,
                centerStaffId: parseInt(this.staffIdId, 10),
                kakaoTemplateId: template.id,
            };
            paymentApi
                .put(`/admin/api/kakaotalk/modify/template/${this.centerId}`, params)
                .then((response) => {
                    alert('수정이 완료되었습니다.');
                    // 수정 성공 후 templateSections 업데이트
                    this.templateSections = this.templateSections.map((section) => {
                        return {
                            ...section,
                            templates: section.templates.map((t) => (t.id === template.id ? { ...t, ...params } : t)),
                        };
                    });
                })
                .catch((error) => {
                    console.error(error);
                    if (error.response && error.response.data.error.result === 502) {
                        alert('카카오톡 검수 등록 또는 반려된 후 수정할 수 있습니다');
                    } else {
                        alert('오류가 발생하였습니다.');
                    }
                });
        },
        // deleteTemplate(template) {
        //     const params = {
        //         kakaoTemplateId: template.id,
        //     };
        //     paymentApi
        //         .delete(`/admin/api/kakaotalk/delete/template/${this.centerId}`, { data: params })
        //         .then((response) => {
        //             console.log('deleteTemplate결과값', response);
        //             alert('삭제 되었습니다.');
        //             // 삭제 성공 후 모든 섹션에서 해당 템플릿 제거
        //             this.templateSections = this.templateSections.map((section) => ({
        //                 ...section,
        //                 templates: section.templates.filter((t) => t.id !== template.id),
        //             }));
        //         })
        //         .catch((error) => {
        //             console.error(error);
        //             if (error.response && error.response.data.error.result === 102) {
        //                 alert('카카오톡 검수 등록이 완료된 후 삭제할 수 있습니다');
        //             } else {
        //                 alert('오류가 발생하였습니다.');
        //             }
        //         });
        // },
        deleteTemplate(template) {
            const params = {
                kakaoTemplateId: template.id,
            };
            console.log('Deleting template:', params); // 삭제하려는 템플릿 ID 로깅
            paymentApi
                .delete(`/admin/api/kakaotalk/delete/template/${this.centerId}`, { params: params }) // data를 params로 변경
                .then((response) => {
                    console.log('deleteTemplate결과값', response);
                    if (response.data.deletedTemplate === null) {
                        alert('템플릿이 성공적으로 삭제되었습니다.');
                        // 템플릿 목록에서 삭제된 템플릿 제거
                        this.templateSections = this.templateSections.map((section) => ({
                            ...section,
                            templates: section.templates.filter((t) => t.id !== template.id),
                        }));
                    } else {
                        alert('템플릿 삭제에 실패했습니다.');
                    }
                })
                .catch((error) => {
                    console.error('Delete template error:', error);
                    alert('오류가 발생하였습니다.');
                });
        },
        async submitTemplate(template) {
            const params = {
                centerId: this.centerId,
                centerStaffId: parseInt(this.staffIdId, 10),
                title: template.title,
                content: template.content,
                useKakao: template.isChecked,
                sendMethod: template.type,
                kakaoTemplateId: template.id, // API에 템플릿 ID 전달
            };

            try {
                const response = await paymentApi.post(`/admin/api/kakaotalk/create/template/${this.centerId}`, params);
                alert(response.data.inspection.message);
                // 성공 후 템플릿 상태 업데이트
                this.updateTemplateStatus(template.id, '심사중');
            } catch (error) {
                console.error(error);
                let errMsg = error.response.data.error.resultMsg == "정상" ? "" : error.response.data.error.resultMsg;
                alert("등록 불가: 핏투데이에 문의주세요. "+errMsg+" ("+error.response.data.error.code+") ");

            }
        },

        // 새로운 메서드: 템플릿 상태 업데이트
        updateTemplateStatus(templateId, newState) {
            this.templateSections = this.templateSections.map((section) => ({
                ...section,
                templates: section.templates.map((t) => (t.id === templateId ? { ...t, state: newState } : t)),
            }));
        },
        async showReturnReason(templateId) {
            try {
                // 템플릿 ID를 요청 본문에 포함
                const requestBody = {
                    templateId: templateId,
                };
                const response = await paymentApi.post(
                    `/admin/api/kakaotalk/reject/reason/${this.centerId}`,
                    requestBody
                );
                const reasons = response.data; // API로부터 받아온 반려 사유 리스트
                if (reasons && reasons.length > 0) {
                    // 첫 번째 반려 사유만 표시
                    this.returnReason = reasons[0].content;
                    this.returnReasonPop = true;
                } else {
                    alert('해당 템플릿의 반려 사유 정보가 없습니다.');
                }
            } catch (error) {
                console.error('반려 사유 가져오기 오류:', error);
                alert('반려 사유 정보를 가져오는 데 실패했습니다.');
            }
        },
        async fetchCategoryCodes() {
            try {
                const response = await paymentApi.get('/admin/api/kakaotalk/category/all');
                const categories = Array.isArray(response.data.data) ? response.data.data : response.data.data;
                const categoryCodes = categories.map((category) => ({ name: category.name, code: category.code })); // 객체 배열 생성

                const selectedCategories = [
                    '건강,심리치료/명상/기타대체의학',
                    '미용,미용,뷰티케어샵/체형클리닉',
                    '일반서비스,기타일반서비스,기타일반서비스',
                    '전문서비스,기타전문서비스,기타전문서비스',
                    '기타서비스,업무알림,업무알림',
                ];

                if (selectedCategories.length > 0) {
                    this.categoryCodes = categoryCodes.filter((category) => selectedCategories.includes(category.name));
                } else {
                    this.categoryCodes = [...categoryCodes];
                }
            } catch (error) {
                console.error('카테고리 코드 목록을 불러오는 데 실패했습니다:', error);
            }
        },
        async fetchSubCategoryCodes(categoryCode) {
            try {
                const response = await paymentApi.get(`/admin/api/kakaotalk/category/one/${categoryCode}`);
                const subCategories = response.data.data; // API 응답에서 중분류 카테고리 데이터를 가져옵니다.

                // 중분류 카테고리 데이터가 있는지 확인합니다.
                if (Array.isArray(subCategories)) {
                    // 중분류 카테고리 이름만 배열에 추가합니다.
                    const subCategoryNames = subCategories.map((subCategory) => subCategory.name);

                    // API 응답으로 받은 중분류 카테고리 이름을 subCategoryCodes 배열에 저장합니다.
                    this.subCategoryCodes = [...subCategoryNames];
                } else {
                    // 중분류 카테고리 데이터가 없습니다.
                    this.subCategoryCodes = ['중분류값이 없습니다'];
                }
            } catch (error) {
                console.error('중분류 카테고리 코드 목록을 불러오는 데 실패했습니다:', error);
                this.subCategoryCodes = [];
            }
        },
        updateSelectedCategoryCode(newValue) {
            this.selectedCategoryCode = newValue;
        },
        updateSelectedSubCategoryCode(newValue) {
            this.selectedSubCategoryCode = newValue;
        },
        async registerPlusFriend() {
            try {
                if (!this.yellowId) {
                    alert('플러스친구 아이디를 입력해주세요.');
                    return;
                }
                if (!this.phoneNumber) {
                    alert('휴대폰번호를 입력해주세요.');
                    return;
                }
                const response = await paymentApi.post(`/admin/api/kakao-talk-profile/request-profile-auth-token/`, {
                    yellowId: this.yellowId,
                    phoneNumber: this.phoneNumber,
                });

                if (response.data.result === 0 && response.data.code === '200') {
                    alert('인증번호를 발송하였습니다.');
                } else {
                    alert(response.data.message);
                }
            } catch (error) {
                console.error(error);
                alert(error.response.data.message);
            }
        },
        async registerProfile() {
            try {
                const response = await paymentApi.post(
                    `/admin/api/kakao-talk-profile/register-profile/${this.centerId}`,
                    {
                        yellowId: this.yellowId,
                        phoneNumber: this.phoneNumber,
                        categoryCode: this.categoryCode,
                        token: this.token,
                    }
                );
                if (response.data.response && response.data.response.resultMsg === '정상') {
                    alert('등록되었습니다');
                } else {
                    alert(response.data.response.resultMsg);
                }
            } catch (error) {
                console.error(error);
                if (error.response && error.response.data && error.response.data.error) {
                    alert(error.response.data.error.message);
                } else {
                    alert('An error occurred');
                }
            }
        },
        async fetchKakaoProfile() {
            try {
                const response = await paymentApi.get(
                    `/admin/api/kakao-talk-profile/get-center-kakao-profile/${this.centerId}`
                );
                this.name = response.data.name;
                this.uuid = response.data.uuid;
                this.categoryCode = response.data.categoryCode;
                this.senderKey = response.data.senderKey;
            } catch (error) {
                console.error(error);
            }
        },
        resetFields() {
            this.yellowId = '';
            this.phoneNumber = '';
            this.token = '';
            this.selectedCategoryCode = '';
        },
        // 페이지 이동
        onClickRouter(path) {
            this.$router.push({ path: `${path}` });
        },
        // '반려' 또는 '심사중' 상태에서는 체크박스 미동작 처리
        async handleCheckboxClick(template) {
            try {
                const useYn = !template.isChecked;
                const response = await paymentApi.put(`/admin/api/kakaotalk/useage/template/${this.centerId}`, {
                    kakaoTemplateId: template.id,
                    useYn: useYn,
                });
                console.log(response.data);
            } catch (error) {
                console.error('API 요청 실패:', error);
            }
        },
    },
};
</script>
<style lang="scss"></style>
